import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useEffect, useRef, useState } from 'react';
import ErrorDisplay from './ErrorDisplay';
import useDidMount from '../../hooks/useDidMount';
import { addDays, getToday, getTomorrow, getYesterday, } from '../../services/date-time.service';
const DatePicker = ({ name, value, max, inputLabel, titleClass, inputClasses, inputIsValid, errorText, onChange, onBlur, required, tabindex, focus, }) => {
    const [hotkey, setHotKey] = useState('');
    const isMounted = useDidMount();
    const inputRef = useRef(false);
    const defaultClass = inputClasses
        ? inputClasses
        : 'block w-full py-3 px-4 mb-3 rounded hover:bg-gray-300 focus:outline-none focus:bg-white focus:border-2 text-gray-600 focus:text-black';
    const inputClass = inputIsValid
        ? defaultClass + ' form-field-valid'
        : defaultClass + ' form-field-invalid';
    useEffect(() => {
        if (isMounted === true) {
            inputRef.current.focus();
        }
    }, [focus]);
    const getHotKeyValue = (hotkey) => {
        if (hotkey === 't') {
            return getToday();
        }
        else if (hotkey === 'm') {
            return getTomorrow();
        }
        else if (hotkey === 'y') {
            return getYesterday();
        }
        else if (hotkey === '30' || hotkey === '60' || hotkey === '90') {
            return addDays(Number(hotkey));
        }
        return '';
    };
    const onBlurHandler = (event) => {
        setHotKey('');
        if (onBlur)
            onBlur(event);
    };
    const onKeyDown = (event) => {
        if (!ValidKey(event.keyCode)) {
            setHotKey('');
        }
        else {
            setHotKey(hotkey + event.key);
            const hotkeyValue = getHotKeyValue(hotkey + event.key);
            if (hotkeyValue !== '') {
                onChange({ target: { value: hotkeyValue, id: name } });
            }
        }
    };
    const ValidKey = (keyCode) => {
        return ((keyCode >= 96 && keyCode <= 105) || //numpad - 0-9
            (keyCode >= 65 && keyCode <= 90) || // A-Z
            (keyCode >= 48 && keyCode <= 57) // 0-9
        );
    };
    return (_jsxs(Fragment, { children: [inputLabel && (_jsxs("label", { className: titleClass
                    ? `${titleClass}`
                    : 'mb-2 block text-sm font-bold uppercase tracking-wide text-gray-700', htmlFor: name, children: [inputLabel, required ? (_jsx("span", { className: "px-1 text-sm text-red-500", children: "*" })) : null] })), _jsx("input", { className: inputClass, id: name, max: max, name: name, onBlur: onBlurHandler, onChange: onChange, onKeyDown: onKeyDown, ref: inputRef, tabIndex: tabindex, type: "date", value: value }), _jsx(ErrorDisplay, { errorText: errorText, isValid: inputIsValid })] }));
};
export default DatePicker;
